// @flow
import client from '../../client'

// Constants
export const SEND_VERIFICATION_EMAIL_ENDPOINT =
  '/auth/users/send_verification_email/'

/**
 * Send email verification email with a link to verify the email address
 * @param {Object} data User data
 * @param {string} data.key User verification key
 * @return {Promise|Error} A resolved Promise with the server response or Rejected with an Error
 */
export const sendEmailVerification = (data: { key: string }): Promise<any> =>
  client
    .post(SEND_VERIFICATION_EMAIL_ENDPOINT, {
      body: data,
    })
    .then((res) => res.success)

export default sendEmailVerification
